import { type ProductResource } from "@exonn/js-sdk";

import { PRODUCT_TYPES } from "src/admin/modules/product/components/shared.tsx";

export const EditProductTabTitle = ({
  resource,
}: {
  resource: ProductResource;
}) => {
  const type = PRODUCT_TYPES[resource.type];
  return (
    <span>
      {type.icon} {resource.sku}
    </span>
  );
};
